const ZH = ({ width, height, color, ...props }) => (
  <svg
    width={width || '24'}
    height={height || '18'}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    <mask
      id="mask0_54_2357"
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="24"
      height="18"
    >
      <rect y="3.42999" width="24" height="17.1429" rx="2" fill="white" />
    </mask>
    <g mask="url(#mask0_54_2357)">
      <rect y="3.42999" width="24" height="17.1429" fill="#F1361D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63367 6.0878L9.46376 6.22932L10.0863 6.79632L10.2279 5.96622L10.7949 5.34365L9.96476 5.20213L9.34218 4.63513L9.20066 5.46523L8.63367 6.0878ZM10.8571 8.99124L11.5764 8.55345L12.4183 8.57292L11.9805 7.8536L12 7.01175L11.2806 7.44954L10.4388 7.43007L10.8766 8.14939L10.8571 8.99124ZM9.88137 13.6908L9.17776 14.1534L9.16784 13.3114L8.70521 12.6078L9.54723 12.5979L10.2508 12.1353L10.2608 12.9773L10.7234 13.6809L9.88137 13.6908ZM10.4924 11.5141L11.3293 11.4213L12.0841 11.7948L11.9913 10.9578L12.3647 10.2031L11.5278 10.2958L10.773 9.92241L10.8658 10.7594L10.4924 11.5141Z"
        fill="#FFDC42"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71431 10.4814L3.69904 11.9181L4.44261 9.5575L2.45354 8.08481L4.92835 8.06253L5.71431 5.71573L6.50026 8.06253L8.97507 8.08481L6.98601 9.5575L7.72957 11.9181L5.71431 10.4814Z"
        fill="#FFDC42"
      />
    </g>
  </svg>
);

export default ZH;
